import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		errorMessage: {
			color: theme.palette.error.main,
			fontWeight: "bold",
		},
		fieldContainer: {
			maxWidth: 576,
			width: "100%",
			[theme.breakpoints.down("sm")]: {
				maxWidth: "100%",
			},
		}
	} satisfies Record<string, CSSObject>)
}
